/**
 * Devex Namespace
 */
devex = devex || {};

/**
 * Util namespace.
 *
 * Contains general utilities
 */
devex.util = devex.util || {};

/**
 * Checks if the email is already in use and depending on the response `callback`
 * method is called with true or false
 * Callback method is gonna handle email validation
 *
 * @param {string} email - email input value
 * @param {function} callback - handle the async response
 *
 * @returns {undefined}
 */
devex.util.validateEmail = function (email, callback) {
  $.ajax({
    url: Routes.check_email_path({ value: email }) + '&field=consultant[login]',
    type: 'GET',
    success: function (response) {
      callback(response.valid);
    },
    error: function (error) {
      callback(error.statusText);
    },
  });
};

/**
 * Scroll the browser view to the element with the Id
 * passed as a parameter.
 *
 * @param {string} id Element Id.
 * @returns {undefined}
 */
devex.util.scrollToElement = function (id) {
  var element = document.getElementById(id);
  element.scrollIntoView({ behavior: 'smooth' });
};

/**
 * Set a cookie in the browser and add days to the expiration date.
 *
 * @param {String} name Name of the cookie
 * @param {String} cookie The cookie
 * @param {Number} days Amount of days to add in the expiration date.
 *
 * @returns {undefined}
 */
devex.util.setCookie = function (name, cookie, days) {
  var CookieDate = new Date();
  CookieDate.setSeconds(CookieDate.getSeconds() + days * 24 * 60 * 60);
  document.cookie =
    name + '=' + cookie + ';domain=.devex.com;path=/;expires=' + CookieDate.toUTCString();
};

/**
 * Adds commas to numbers
 * @param {number} x Number to format
 * @returns {string} Formatted number with commas (e.g., '1,000,000')
 */
devex.util.numberWithCommas = function (x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * Rounds number to max `decimalPlaces` decimal points and removes trailing
 * zeros.
 *
 * @param {Number|String} x Number which should be rounded
 * @param {Integer=} decimalPlaces Number of decimal places to keep (default: 2)
 * @returns {String}
 */
devex.util.roundNumber = function (x, decimalPlaces) {
  decimalPlaces = decimalPlaces || 2;
  return parseFloat(x)
    .toFixed(decimalPlaces)
    .replace(/\.?0+$/, '');
};

/**
 * Returns the number rounded to thousands, millions, or billions whichever is
 * applicable (or not rounded if it is smaller than 1000). Leaves up to two
 * decimal places and is followed the word "Thousand", "Million", or "Billion"
 * respectively.
 *
 * @param {Number|String} x Number which should be rounded
 * @param {object} options Options object with the following properties
 *                         - shortFormat: Forces short formatting (Thousand = K,
 *                           Million = M, Billion = B)
 * @returns {String}
 */
devex.util.numberToHuman = function (x, options) {
  if (!options) {
    options = {};
  }

  if (x < 1e3) {
    return devex.util.roundNumber(x);
  }

  if (x < 1e6) {
    return devex.util.roundNumber(x / 1e3) + (options.shortFormat ? 'K' : ' Thousand');
  }

  if (x < 1e9) {
    return devex.util.roundNumber(x / 1e6) + (options.shortFormat ? 'M' : ' Million');
  }

  return devex.util.roundNumber(x / 1e9) + (options.shortFormat ? 'B' : ' Billion');
};

/**
 * Returns the number rounded to thousands, millions, or billions whichever is
 * applicable (or not rounded if it is smaller than 1000). Leaves up to two
 * decimal places and is followed the letter "K", "M", or "B" respectively.
 *
 * @param {Number|String} x Number which should be rounded
 * @returns {String}
 */
devex.util.numberToHumanAbbreviated = function (x) {
  return devex.util.numberToHuman(x, {
    shortFormat: true,
  });
};

/**
 * Returns the same string with its first letter capitalized
 *
 * @param string
 * @returns {string}
 */
devex.util.capitalize = function (string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Returns the same string with each word's first letter capitalized
 *
 * @param string
 * @returns {string}
 */
devex.util.titleize = function (string) {
  return string.split(' ').map(devex.util.capitalize).join(' ');
};

/**
 * Converts camelCase to snake_case
 *
 * @param string
 * @returns {string}
 */
devex.util.snakeCase = function (string) {
  return string.replace(/([A-Z])/g, function ($1) {
    return '_' + $1.toLowerCase();
  });
};

/**
 * Returns the same string with underscores replaced by spaces and all
 * characters expect the first one lower cased. The first letter is being
 * capitalized by default. The capitalization behavior can be changed via the
 * passed options hash.
 *
 * @param string
 * @param options – optional, can either be `capitalize: true` (default) or
 *                  `titleize: true`. Pass `capitalize: false` to deactivate
 *                  capitalization.
 * @returns {string}
 */
devex.util.humanize = function (string, options) {
  if (typeof string !== 'string') {
    return string;
  }
  string = string.replace(/_/g, ' ').toLowerCase();

  if (options === undefined || options.capitalize) {
    return devex.util.capitalize(string);
  }

  if (options.titleize) {
    return devex.util.titleize(string);
  }

  return string;
};

/**
 * Takes a string, lower cases it and replaces spaces with underscores, reverts
 * the effects of `devex.util.humanize`
 *
 * @param {string} string - input string that should be snail-cased
 * @returns {string}
 */
devex.util.dehumanize = function (string) {
  return string.toLowerCase().replace(/\s+/g, '_');
};

/**
 * Format a date object or date string to our standard format, e.g. "3 Nov 2015"
 *
 * @param date or string
 * @returns {string}
 */
devex.util.formatDate = function (date) {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  var month_short_names = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  return (
    date.getUTCDate() + ' ' + month_short_names[date.getUTCMonth()] + ' ' + date.getUTCFullYear()
  );
};

/**
 * Takes two arrays and removes the entries from the second array from the first
 *
 * @param {Array} sourceSet: source set
 * @param {Array} substractSet: these items will be removed from sourceSet
 * @param {function} compare: comparison function that accepts two params to
 *                   compare
 *
 * @example
 * substractSet([1,2,3], [2,3], funciton(a,b) {a==b])
 * => [1]
 *
 * The 3rd argument is a comparision function, which will by default compare
 * the values of [item].id
 *
 * Careful, this runs in O(n^2), so it might have performance problems on
 * big data sets.
 */
devex.util.substractSet = function (sourceSet, substractSet, compareFn) {
  if (compareFn === undefined) {
    compareFn = function (obj1, obj2) {
      return obj1.id === obj2.id;
    };
  }
  return _.filter(sourceSet, function (sourceItem) {
    return (
      _.filter(substractSet, function (substractItem) {
        return compareFn(sourceItem, substractItem);
      }).length === 0
    );
  });
};

/**
 * Scrolls for first bootstrap error on page
 *
 * @returns {boolean} true if errors on page, otherwise false
 */
devex.util.scrollToFirstError = function () {
  var errors = $(document).find('.form-group.has-error');
  if (errors.length !== 0) {
    $('html, body').animate(
      {
        scrollTop: errors.offset().top,
      },
      'slow'
    );
    return true;
  }
  return false;
};

/**
 * HTML5 placeholders
 */
devex.util.fixInputPlaceholders = function () {
  // if browser does not support HTML5 placeholders
  if (typeof document.createElement('input').placeholder == 'undefined') {
    $('[placeholder]')
      .focus(function () {
        var input = $(this);
        if (input.val() === input.attr('placeholder')) {
          input.val('');
          input.removeClass('input-placeholder');
        }
      })
      .blur(function () {
        var input = $(this);
        if (input.val() === '' || input.val() == input.attr('placeholder')) {
          input.addClass('input-placeholder');
          input.val(input.attr('placeholder'));
        }
      })
      .blur()
      .parents('form')
      .submit(function () {
        $(this)
          .find('[placeholder]')
          .each(function () {
            var input = $(this);
            if (input.val() === input.attr('placeholder')) {
              input.val('');
            }
          });
      });
  }
};

/**
 * Takes two dates, compare them and return the difference of time between the
 * 2 of them, expressed in days.
 *
 * @param {Date} date1: the latest date
 * @param {Date} date2: the newest date
 *
 */
devex.util.differenceInDays = function (date1, date2) {
  var timeDiff = date2.getTime() - date1.getTime();
  return Math.ceil(timeDiff / (1000 * 3600 * 24));
};

/**
 * Takes 1 date as a string, compares it with current date and returns a string
 * containing the difference of time between the 2 of them, expressed in days
 * and the following words ' days ago'
 *
 * @param {String} date: the date to compare to
 *
 */

devex.util.daysAgo = function (date) {
  var numberDays = devex.util.differenceInDays(new Date(date), new Date());

  if (isNaN(numberDays)) {
    return '';
  } else if (numberDays == 1) {
    return numberDays + ' day ago';
  } else {
    return numberDays + ' days ago';
  }
};

/**
 * pluralize our most common class names
 *
 * @param {String} className: the date to compare to
 *
 */

devex.util.classToRestPlural = function (className) {
  switch (className.toLowerCase().replace(/[\-_]/, '')) {
    case 'openopportunity':
    case 'open_opportunity':
      return 'open_opportunities';
    default:
      return className.toLowerCase() + 's';
  }
};

/**
 * Takes a number (string or integer) and a unit already pluralized (string).
 * Returns the unit pluralized or depluralized, depending on the number
 *
 * @param {String} number: the number (e.g. '645')
 * @param {String} pluralizedUnit: the pluralized unit (e.g. 'meters')
 *
 */

devex.util.depluralizeUnit = function (number, pluralizedUnit) {
  if (pluralizedUnit) {
    if (parseInt(number) > 1) {
      return pluralizedUnit;
    } else {
      return pluralizedUnit.replace('s', '');
    }
  }
};

/**
 * Generates a slug from a string
 *
 * @param {String} text: text to sluggify
 *
 */

devex.util.slugify = function (text, limit) {
  if (limit) {
    text = text.substring(0, limit);
  }
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
};

/**
 *
 * @param {String} text - Can already be slugified or not
 * @param {String|Integer} id - Either numerical ID or ID as string
 *
 * @returns {String} slug_and_id
 *
 */
devex.util.createSlugAndId = function (text, id) {
  return devex.util.slugify(text) + '-' + id.toString();
};

/**
 * Transforms an array made of 1 or more objects and returns an object.
 * The returned object size is equal to the array argument length.
 * The array's index of each object is the key to access its properties.
 *
 * Real life use case: In the countries page, we want to create a path that
 * contains the following format:
 *
 * filter[office_locations][0][name]=wd&filter[office_locations][0][foo]=bar
 * instead of
 * filter[office_locations][][name]=wd&filter[office_locations][][foo]=bar
 *
 * @example
 * var arr = [{ name: 'foo', place_key: 'bar' }];
 * objectifyArray(arr) => {0: { name: 'foo', place_key: 'bar'}}
 *
 * @param array {Array}
 *
 * @returns {Object} - Returns an object where the index of each array's object
 * is the key to access that object
 */
devex.util.objectifyArray = function (array) {
  return array.reduce(function (object, value, index) {
    object[index] = value;
    return object;
  }, {});
};

/**
 * Return the first leaf node, whether it's a string, a boolean, an array
 * or an integer
 *
 * @param {Object} obj: obj with at least one leaf node
 *
 * @example
 *  var obj = {a: {b: {c: 'aString'}}};
 *  getFirstLeafNode(obj) => 'aString'
 *
 */
devex.util.getFirstLeafNode = function (obj) {
  var prop;
  for (prop in obj) {
    if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
      return devex.util.getFirstLeafNode(obj[prop]);
    } else {
      return obj[prop];
    }
  }
};

/**
 * Return true ois user Agent is a mobile phone
 *
 */
devex.util.isMobile = function () {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  } else {
    return false;
  }
};

/**
 * Get rid of all the HTML tags inside a string
 * http://stackoverflow.com/questions/17289448/angularjs-to-output-plain-text-instead-of-html
 *
 * @param {string} inputString - A string, potentially containing HTML tags
 * @returns {string} The string, without the HTML tags
 */
devex.util.htmlToPlaintext = function (inputString) {
  return inputString ? String(inputString).replace(/<[^>]+>/gm, '') : '';
};

/**
 * Takes a bookmarkedSearch object and returns the first alert onwed by the
 * current user. If user doesn't have any active alert yet, returns undefined
 *
 * @param {array} alerts - One or more alerts, each containing an ID, an integer
 * how_often and a user_id, as consultant_id
 * @returns {object} The first alert that the current user owns, containing an
 * ID, an integer how_often and a user_id, as consultant_id if there is a match,
 * if not, undefined
 */
devex.util.findMyAlert = function (alerts) {
  return _.find(alerts, function (alert) {
    return devex.data.user.id === alert.consultant_id;
  });
};

/**
 * Checks if the property exists with a valid value (not empty string,
 * not 0 number, not empty array, not empty object, not null, not undefined)
 * on the object
 *
 * @param {object} object - Object where check the property
 * @param {string} property - Property to be checked
 * @returns {boolean} true if the property exists on the object with a valid
 *                    value, false if not
 */
devex.util.containsProp = function (object, property) {
  var result = false;

  if (property) {
    var value = object[property];

    if (value) {
      if (typeof value === 'object') {
        result = Boolean(Object.keys(value).length);
      } else {
        result = true;
      }
    }
  }

  return result;
};

/**
 * Checks if any of the properties exists with a valid value (not empty string,
 * not 0 number, not empty array, not empty object, not null, not undefined)
 * on the object
 *
 * @param {object} object - Object where check the properties
 * @param {array} properties - Properties to be checked
 * @returns {boolean} true if any of the properties exists on the object with a valid
 *                    value, false if not
 */
devex.util.containsAnyProp = function (object, properties) {
  return properties.some(function isValidProperty(property) {
    return devex.util.containsProp(object, property);
  });
};

/**
 * Checks if all of the properties exists with a valid value (not empty string, not 0 number,
 * not empty array, not empty object, not null, not undefined) on the object
 *
 * @param {object} object - Object where check the properties
 * @param {array} properties - Properties to be checked
 * @returns {boolean} true if all of the properties exist on the object with a valid value, false
 * if not
 */
devex.util.containsAllProps = function (object, properties) {
  return properties.every(function isValidProperty(property) {
    return devex.util.containsProp(object, property);
  });
};

/**
 * Checks if the value exists inside the array of values
 *
 * @param {any} value - Value to be checked
 * @param {array} values - Array of values
 * @returns {boolean} true if the value exists on the array of values,
 *                    false if not
 */
devex.util.propertyIncludes = function (value, values) {
  return values.indexOf(value) !== -1;
};

/**
 * Returns a separated text representation of an array
 *
 * @param {array} list to be humanized
 * @returns {string} Humanized string representation
 *
 */
devex.util.humanizeList = function (list, options) {
  var listLength = list.length,
      humanizedList = '',
      options = _.extend(
        {
          separator: ', ',
          conjunction: ' and ',
          wrapStart: '',
          wrapEnd: '',
        },
        options
      );

  if (listLength === 1) {
    humanizedList = options.wrapStart + list[0] + options.wrapEnd;
  } else if (listLength > 1) {
    for (var i = 0; i < listLength; i++) {
      if (i === listLength - 1) {
        humanizedList += options.conjunction;
      } else if (i !== 0) {
        humanizedList += options.separator;
      }
      humanizedList += options.wrapStart + list[i] + options.wrapEnd;
    }
  }

  return humanizedList;
};

/**
 * Takes two dates and returns a string representation with range.
 * Assumes each month has 365/12 days.
 * This helper is used to display education and employment date ranges.
 * Example output: August, 2008 - June, 2015 (6 years, 10 months)
 * TODO: Once we adopt ES6 we can change to JS Date methods for  comparison.
 *
 * @param {Date} startDate - start date
 * @param {Date} [endDate] - end date
 *
 * @returns {string} month, year - month, year (months, years)
 */
devex.util.formatTimeSpan = function (startDate, endDate) {
  var days = devex.util.differenceInDays(startDate, endDate || new Date());
  var years = Math.floor(days / 365);
  var months = Math.floor((days % 365) / (365 / 12));
  var spans = [];
  var dates = [];
  var monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  if (years) {
    spans.push(years + (years > 1 ? ' years' : ' year'));
  }

  if (months) {
    spans.push(months + (months > 1 ? ' months' : ' month'));
  }

  dates.push(monthNames[startDate.getMonth()] + ', ' + startDate.getFullYear());

  if (endDate) {
    dates.push(monthNames[endDate.getMonth()] + ', ' + endDate.getFullYear());
  } else {
    dates.push('Present');
  }

  return dates.join(' - ') + (spans.length ? ' (' + spans.join(', ') + ')' : '');
};
